import { render, staticRenderFns } from "./MediaBgImage.vue?vue&type=template&id=0206f6c4&"
import script from "./MediaBgImage.vue?vue&type=script&lang=js&"
export * from "./MediaBgImage.vue?vue&type=script&lang=js&"
import style0 from "./MediaBgImage.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports